module.exports = __webpack_public_path__ + "582f52b35ba735cf971513cf55a9381a.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/team-member-duel.png
// module id = 654
// module chunks = 0